import { createContext, useContext } from 'react';
export const UserInfoContext = /*#__PURE__*/createContext(undefined);
export const useUserInfoContext = () => {
  return useContext(UserInfoContext);
};